import React from "react";
import { MarqueeHeaderWrapper } from "./style";

export const MarqueeHeader = (props) => {
  return (
    <MarqueeHeaderWrapper sectionTitle={props.sectionTitle}>
      <div className="marquee">
        <div className="track">
          <div className="content">
            <span>{props.text}</span>
            <span>{props.text}</span>
            <span>{props.text}</span>
            <span>{props.text}</span>
            <span>{props.text}</span>
            <span>{props.text}</span>
          </div>
        </div>
      </div>
    </MarqueeHeaderWrapper>
  );
};
